import React from "react";
const urlApi = "https://api.institucional.global.sidom.io";
export default function VideoComex({
  video,
  poster,
  controls,
  autoPlay,
  muted,
  loop,
}) {
  console.log("Video URL:", controls);
  const posterUrl = poster ? `${urlApi}${poster}` : undefined;
  const videoUrl = video ? `${urlApi}${video}` : undefined;

  return (
    <section className="w-full flex flex-col items-center justify-center">
      <div className="w-full aspect-video h-[80vh] overflow-hidden mb-8 relative">
        <video
          controls={controls}
          autoPlay={autoPlay}
          muted={muted}
          loop={loop}
          poster={posterUrl}
          className="w-full h-full object-cover shadow-md absolute top-0 left-0 z-0"
        >
          {videoUrl && <source src={videoUrl} type="video/mp4" />}
          Tu navegador no soporta la reproducción de video.
        </video>
        {/* Overlay degradado, solo efecto visual, no tapa el video */}
        <div className="absolute top-0 left-0 w-full h-full z-10 pointer-events-none bg-gradient-to-b from-sidom-blue/60 via-transparent to-sidom-blue/40" />
      </div>
    </section>
  );
}
